import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { getWhatsAppLink } from "@/lib/whatsapp";

const MESSAGE =
  "Hola, quiero avanzar con la propuesta de marca de Coressen para Mamma Pasta.";

const MammaCTA = () => {
  const whatsappUrl = getWhatsAppLink(MESSAGE);

  return (
    <section
      id="cta-final"
      className="py-28 md:py-40 relative overflow-hidden"
      style={{
        background: "linear-gradient(180deg, hsl(215 48% 20%), hsl(220 69% 2%))",
      }}
    >
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at center, rgba(122,183,253,0.22) 0%, rgba(29,74,140,0.08) 40%, transparent 75%)",
        }}
        aria-hidden="true"
      />

      <div className="relative z-10 container px-4 max-w-3xl mx-auto text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-xs md:text-sm font-semibold tracking-[0.35em] uppercase mb-8 text-white/70"
        >
          El próximo paso
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="font-display text-4xl md:text-6xl font-bold text-white leading-[1.05] mb-8"
        >
          La fecha la definís vos
          <br />
          <span style={{ color: "#7ab7fd" }}>¿Cuándo iniciamos?</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-base md:text-lg text-white/70 leading-relaxed mb-12 max-w-xl mx-auto"
        >
          Esta propuesta es el punto de partida.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-3 px-10 py-5 md:px-12 md:py-6 rounded-full text-base md:text-lg font-semibold text-white transition-all duration-300 hover:scale-[1.02]"
            style={{
              background: "linear-gradient(135deg, #4F46E5 0%, #7ab7fd 100%)",
              boxShadow: "0 18px 50px -12px rgba(79,70,229,0.6)",
            }}
          >
            Confirmar el próximo encuentro
            <ArrowRight className="w-5 h-5 md:w-6 md:h-6 transition-transform group-hover:translate-x-1" />
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.45 }}
          className="mt-12"
        >
          <p
            className="font-display italic text-xl md:text-2xl"
            style={{ color: "#7ab7fd" }}
          >
            {"\n"}
          </p>
          <p className="mt-2 text-[11px] tracking-[0.2em] uppercase text-white/45">
            {"\n"}
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default MammaCTA;
